import { Route, Redirect, Switch, useParams } from 'react-router-dom';
import { userHasTasksEnabledRedir } from '../core/auth';

const MaintenanceTasksRoute = () => {
  const { site } = useParams<{ site: string }>();
  return (
    <Switch>
      <Route path="/:site/maintenance/new">
        <Redirect to={`/${site || ''}/tasks/maintenance`} />
      </Route>
      <Route path="/:site/maintenance/:task">
        <Redirect to={`/${site || ''}/tasks/maintenance`} />
      </Route>
      <Route path="/:site/maintenance">
        <Redirect to={`/${site || ''}/tasks/maintenance`} />
      </Route>
    </Switch>
  );
};

export default userHasTasksEnabledRedir(MaintenanceTasksRoute);
